import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/14/principle/tapping-machine-bare-concrete-floor.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      url: `${config.ASSETS_URL}/03/14/principle/tapping-machine-bare-concrete-floor.wav`,
      text: "Sound sample",
      icon: "cis-volume-high",
      theme: "secondary",
      shape: "round",
    },
  },
];
